import Sentry from 'sentry';

var shouldCheckPlz = true;
var lastPLZ = null;
var plzInProgress = false;

global.PHVO = {
    branch: 'phvo',
    // dry-run marker:
    dry: true,
    type: 'phvo',
    o_possible: true,
    v_peril: true,
    v_risk: true,
    valid: false,

    canCalc: function(e) {
		PRIV.calcable = PHVO.haveRisk() && PHVO.havePeril();

		BC.debug('PHVO.canCalc(): ', PRIV.calcable, 64);

		return PRIV.calcable;
    },

    change: function(e) {
		BC.debug('PHVO.change() starting:', e, 64);

		if (! ALL.mobile && ! PHVO.canCalc(e)) {
			ALL.chgProduct(PHVO.type, null);
			ALL.notifyHeight();
			return;
		}

		//JQ('#div_' + PHVO.type + '_vers').show();

		if (!ALL.mobile) {
			PHVO.haveInfo();
		}
		PHVO.recalc();
		ALL.notifyHeight();
    },

    chgSB: function(e) {
		BC.debug('PHVO.chgSB() starting:', this, 64);

		var _sb = JQ(this).val();

		JQ('#div_' +  PHVO.type + '_sb button').each(function(k,v) {
			if (JQ(v).val() == _sb) {
				JQ(v).removeClass('inactive').addClass('active');
			} else {
				JQ(v).removeClass('active').addClass('inactive');
			}
		});

		BC.debug('PHVO.chgSB() Setting SB to', _sb, 64);

		JQ('#f_' +  PHVO.type + '_sb').val(_sb);

		PHVO.change();
		ALL.notifyHeight();
    },

    chgSB_old: function(e) {
	BC.debug('PHVO.chgSB_old() starting:', this, 64);
        var _sb;
        try {
            _sb = JQ(this).prop('id').split('_').pop();
        }
        catch (e) {
            _sb = '1000';
        }
        JQ('#div_' +  PHVO.type + '_sb button').each(function(k,v) {
            if (JQ(v).prop('id').split('_').pop() == _sb)
                JQ(v).removeClass('inactive').addClass('active');
            else
                JQ(v).removeClass('active').addClass('inactive');
        });
	BC.debug('PHVO.chgSB() Setting SB to', _sb, 64);
        JQ('#f_' +  PHVO.type + '_sb').val(_sb);
        PHVO.change();
        ALL.notifyHeight();
    },

    chkDA: function(div) {
	// Kann DA/Antrag geposted werden?
	BC.debug('PHVO.chkDA() starting in div', div, 64);
        var needed;
        if (div == 4)
            needed = {vv0  : [true, 'Angabe frühere Antragsablehungen fehlt'],
                      vv1  : [true, 'Angabe, ob eine Vorversicherung bestand, fehlt'],
                      vv1a : [false, 'Erläuterung für nicht vorhandene Vorversicherung in den letzten 5 Jahren fehlt.'],
                      vv2  : [false, 'Angabe, wer den Vorversicherungsvertrag gekündigt hat, fehlt.'],
		      vv3  : [true, 'Name der Vorversicherungsgesellschaft fehlt.'],
		      vv4  : [true, 'Nummer des Vorversicherungsvertrages fehlt.'],
		      vv5  : [true, 'Ablaufdatum des Vorversicherungsvertrages.'],
		      vv6a : [false, 'Beschreibung, Höhe und Datum des Vorschadens fehlen.'],};
        else
            needed = {iban : [false, 'IBAN fehlt.']};

	JQ('#btn_da_ok').button('disable');

        // Frühere (abgelehnte) Anträge:
        if (div == 4) {
	    if (JQ('#f_da_vv0_1').is(':checked')) {
	        ALL.showHint('Die Übernahme des Versicherungsschutzes ist aufgrund vorheriger Antrags-Ablehnungen bei der Waldenburger leider nicht möglich.', true);
	        return false;
	    } else if (! JQ('#f_da_vv0_0').is(':checked')) {
                return false;
            }
	    if (JQ('#f_da_vv2_2').is(':checked')) {
	        ALL.showHint('Die Übernahme des Versicherungsschutzes ist aufgrund der Kündigung durch den Vorversicherer bei der Waldenburger leider nicht möglich.', true);
	        return false;
	    }
            // Angaben Vorversicherung:
	    if (JQ('#f_da_vv1_1').is(':checked')) {
	        // Es bestand eine Vorversicherung
	        JQ('#div_da_vv2').show();
	        needed.vv2[0] = true;
	        JQ('#div_da_vv3').show();
	        needed.vv3[0] = true;
	        JQ('#div_da_vv4').show();
	        needed.vv4[0] = true;
	        JQ('#div_da_vv5').show();
	        needed.vv5[0] = true;
	        JQ('#div_da_vv1a').hide();
	        needed.vv1a[0] = false;
	    } else if (JQ('#f_da_vv1_0').is(':checked')) {
	        // Es bestand keine Vorversicherung
	        JQ('#div_da_vv2').hide();
	        needed.vv2[0] = false;
	        JQ('#div_da_vv3').hide();
	        needed.vv3[0] = false;
	        JQ('#div_da_vv4').hide();
	        needed.vv4[0] = false;
	        JQ('#div_da_vv5').hide();
	        needed.vv5[0] = false;
	        BC.debug('PHVO.chkDA(): Vorversicherungsfrage - ', 'NON Unfall', 64);
	        JQ('#div_da_vv1a').show();
	        needed.vv1a[0] = true;
	        if (JQ(this).prop('id') === 'f_da_vv1_0') ALL.showHint('Bitte erläutern Sie in dem entsprechenden Feld kurz, warum in den letzten ' + PRIV.vv_yy + ' Jahren kein Versicherungsschutz vorhanden war.');
	    } else {
                // Frage Vorversicherung nicht beantwortet
                return false;
            }
            ALL.notifyHeight();
	    // Anzahl Vorschäden in den letzten 5 bzw. 10 Jahren
	    if (JQ('#f_da_vv6').length) {
                BC.debug('PHVO.chkDA() - f_da_vv6: ' + JQ('#f_da_vv6').val() + ' Vorschäden', this, 64);
	        if (JQ('#f_da_vv6').val() === '0') {
		    // Keine Vorschäden
		    JQ('#div_da_vv6a').hide();
		    ALL.notifyHeight();
		    needed.vv6a[0] = false;
	        } else if (JQ('#f_da_vv6').val() === '1') {
		    // Ein Vorschaden, Erläuterung benötigt
		    JQ('#div_da_vv6a').show();
		    needed.vv6a[0] = true;
		    ALL.notifyHeight();
		    if (! ALL.mobile && ! JQ('#f_da_vv6a').val()) ALL.showHint('Bitte erläutern Sie in dem entsprechenden Feld den Schaden inkl. Schadenjahr und Schadenhöhe.');
	        } else if (JQ('#f_da_vv6').val() !== '0' && JQ('#f_da_vv6').val() !== '1') {
		    JQ('#div_da_vv6a').hide();
		    ALL.notifyHeight();
		    ALL.showHint('Die Übernahme des Versicherungsschutzes durch die Waldenburger Versicherung ist bei mehr als einem Vorschaden in den vergangenen Jahren leider nicht möglich.', true);
		    return false;
	        }
	    }
        } else if (div == 5) {
	    if (JQ('#f_da_za_1').is(':checked')) {
	        // Zahlung per Lastschrift, Konto benötigt
	        JQ('#div_da_iban').show();
	        needed.iban[0] = true;
	    } else {
	        // Zahlung per Rechnung, kein Konto benötigt
	        JQ('#div_da_iban').hide();
	        needed.iban[0] = false;
	    }
	    ALL.notifyHeight();
        }
	JQ.each(needed, function (k, v) {
	    BC.debug('PHVO.chkDA() - Looping through in div ' + div, [k, v], 64);
	    // Prüfe nochmals, ob alle erforderlichen Felder (var needed) gefüllt sind.
	    // Aber nur, wenn die Felder keine options sind, dafür erfolgt die Prüfung
	    // separat.
	    if (JQ('#f_da_' + k + '_0').length || JQ('#f_da_' + k + '_1').length) return true;
	    if (v[0] && ! JQ('#f_da_' + k).val()) {
		if (! ALL.mobile) ALL.showHint('Die Verarbeitung des Antrags ist nicht möglich: ' + v[1]);
		JQ('#f_da_' + k).prop('required', true).focus();
		PRIV.canDA = false;
		BC.debug('PHVO.chkDA() - Missing info for #f_da_' + k, v[1], 64);
		return false;
	    } else if (v[0] && JQ('#f_da_' + k).val()) {
		PRIV.canDA = true;
	    } else {
		JQ('#f_da_' + k).prop('required', false);
	    }
	});
        //if (div == 4) return true;
        //PRIV.canDA = false;
	if (div == 5 &&
            JQ('#f_da3_0').is(':checked') &&
	    JQ('#f_da3_1').is(':checked') &&
	    JQ('#f_da3_2').is(':checked') &&
	    (! JQ('#f_da3_3').length ||
	     JQ('#f_da3_3').is(':checked'))) {
	    // Alle Bestätigungen im letzten Block vorhanden!
	    // Prüfe einzelne Felder
	    if (needed.iban[0] &&
		(! JQ('#f_da_iban').val() ||
		 ! JQ('#f_da_levok').is(':checked'))) {
                BC.debug('PHVO.chkDA(), Missing IBAN', this, 64);
		//ALL.showHint('Die IBAN und/oder das SEPA-Mandat sind nicht ausgefüllt.');
		PRIV.canDA = false;
		return false;
	    } else if (needed.iban[0] &&
                       JQ('#f_da_levok').is(':checked') &&
                       JQ('#f_da_iban').val() &&
                       chk_iban(JQ('#f_da_iban').val()) != '1') {
		ALL.showHint('Die IBAN ist nicht korrekt, bitte überprüfen Sie die Eingabe.');
                BC.debug('PHVO.chkDA(), IBAN-check failed', this, 64);
		PRIV.canDA = false;
		return false;
	    }
	    JQ.each(needed, function (k, v) {
		BC.debug('PHVO.chkDA() - Looping through ', [k, v], 64);
		// Prüfe nochmals, ob alle erforderlichen Felder (var needed) gefüllt sind.
		// Aber nur, wenn die Felder keine options sind, dafür erfolgt die Prüfung
		// separat.
		if (JQ('#f_da_' + k + '_0').length || JQ('#f_da_' + k + '_1').length) return true;
		if (v[0] && ! JQ('#f_da_' + k).val()) {
		    if (! ALL.mobile) ALL.showHint('Die Verarbeitung des Antrags ist nicht möglich: ' + v[1]);
		    JQ('#f_da_' + k).prop('required', true).focus();
		    PRIV.canDA = false;
		    BC.debug('PHVO.chkDA() - Missing info for #f_da_' + k, v[1], 64);
		    return false;
		} else if (v[0] && JQ('#f_da_' + k).val()) {
		    PRIV.canDA = true;
		} else {
		    BC.debug('PHVO.chkDA() - Problem with ' + k + ', Unsetting required', v[1], 64);
		    JQ('#f_da_' + k).prop('required', false);
		    PRIV.canDA = true;
		}
	    });
	    if (ALL.mobile && (! PRIV.an_read || ! PRIV.wd_read)) {
		PRIV.canDA = false;
		ALL.showHint('Bitte öffnen Sie mittels obiger Links das Angebot und/oder laden die Bedingungen herunter.');
		JQ('#f_da3_1').attr('checked', false)
		return PRIV.canDA;
	    } else if (! PRIV.an_read) {
                PRIV.canDA = false;
		//PRIV.canDA = ! WALDI;
                BC.debug('PHVO.chkDA(): Offer not downloaded', '', 64);
                //ALL.showHint('Bitte laden Sie das Angebot herunter.')
		return PRIV.canDA;
            }
	    BC.debug('PHVO.chkDA():', [PRIV.canDA, needed], 64);
	    if (PRIV.canDA) {
		JQ('#btn_da_ok').button('enable');
		JQ('#f_da_set').val(1);
		ALL.notifyHeight();
	    }
	}
	BC.debug('PHVO.chkDA() ends:', [PRIV.canDA, needed], 64);
	return PRIV.canDA;
    },

    chkDivReady: function(btn) {
		var r;

		BC.debug('PHVO.chkDivReady():', btn, 64);

		try {
			var b = BC.get_id(btn);

			var p = ALL.get_box_id(b);

			if (!p) {
				return false;
			}

			var d = BC.get_id(p);

			var phvoPrice = parseInt(JQ('#f_' +  PHVO.type + '_vs').val());
		}
		catch (e) {
			BC.debug('PHVO.chkDivReady() rised an exception:', e, 16);

			Sentry.captureException(e);

			return false;
		}

		if (!d) {
			return false;
		}

		BC.debug('PHVO.chkDivReady() called for ' + b + ' in ' + d, btn, 64);

		ALL.chkDivReady(d, true);

		switch(d) {
			case '#div_0':
				return true;
			case '#div_1':
				var isStepOneValid = true;

				// abort if there is no price
				if (!phvoPrice) {
					ALL.chgMobButton('#btn_fwd_1', false);
					return false;
				}

				// check if the price is has a valid value
				if (phvoPrice < 500 || phvoPrice > 250000) {
					isStepOneValid = false;
				}

				// check if the invalid option from "Montageort" is selected -> "Fassaden-, Vertikal- und Bodenanlagen"
				if (JQ("#f_phvo_mo_9").is(":checked")) {
					isStepOneValid = false;
				}

				// check if the invalid option from "Montageart" "Aufgeständert" (f_phvo_ma_2) is selected -> "Aufgeständert"
				if (JQ("#f_phvo_ma_2").is(":checked")) {
					var message = "Aufgeständerte Solaranlagen sind online nicht versicherbar. <br/> <br/> Bitte wenden Sie sich direkt an die Waldenburger Versicherung AG"

					isStepOneValid = false;

					ALL.showHint(message, false, true);
				}

				if (isStepOneValid) {
					BC.debug('PHVO.chkDivReady(): ' + d + ' is ready!', '', 64);
					JQ('#f_phvo_vs2').val(JQ('#f_phvo_vs').val());
				}

				ALL.chgMobButton('#btn_fwd_1', isStepOneValid);
				return isStepOneValid;
			case '#div_2':
				// if haftpflicht is selected show m002_06
				if (JQ("#f_phvo_hp_1").is(":checked")) {
					JQ("#m002_06").show();
				} else {
					JQ("#m002_06").hide();
				}

				if (JQ('#f_' + PHVO.type + '_batsys_0').is(':checked')) {
					JQ('#div_' + PHVO.type + '_batprod').addClass('hidden');

					JQ('#div_' + PHVO.type + '_battyp').addClass('hidden');

					JQ('#f_' + PHVO.type + '_batprod').val('nicht vorhanden');

					JQ('#f_' + PHVO.type + '_battyp').val('---');
				} else if (JQ('#f_' + PHVO.type + '_batsys_1').is(':checked')) {
					JQ('#div_' + PHVO.type + '_batprod').removeClass('hidden');

					JQ('#div_' + PHVO.type + '_battyp').removeClass('hidden');

					if (JQ('#f_' + PHVO.type + '_batprod').val() == 'nicht vorhanden') {
						JQ('#f_' + PHVO.type + '_batprod').val('');
					}

					if (JQ('#f_' + PHVO.type + '_battyp').val() == '---') {
						JQ('#f_' + PHVO.type + '_battyp').val('');
					}
				}

				if (JQ('#f_' + PHVO.type + '_hp_1').is(':checked')) {
					JQ('#div_' + PHVO.type + '_haft').show();
				} else {
					JQ('#div_' + PHVO.type + '_haft').hide();
				}
				ALL.notifyHeight();

				// deny values over 50 for flameable stuff
				if (parseInt(JQ("#f_phvo_flamcbm").val()) > 50) {
					var message = "Solaranlagen auf Gebäuden mit Lagerung von feuergefährlichen Stoffen über 50 cbm sind online nicht versicherbar. <br/> <br/> Bitte wenden Sie sich direkt an die Waldenburger Versicherung AG"

					ALL.showHint(message, false, true);

					ALL.chgMobButton('#btn_fwd_2', false);
					return false;
				}

				// // invalid if "ART DES GEWERBEBETRIEBES" has no value but in the first div f_phvo_mo_2 or f_phvo_mo_3 is checked
				// if ((JQ("#f_phvo_mo_2").is(":checked") || JQ("#f_phvo_mo_3").is(":checked")) && 0 === JQ("#f_phvo_gwbetrieb").val().length) {
				// 	ALL.chgMobButton('#btn_fwd_2', false);
				// 	return false;
				// }

				// only show "Erhöhung der Haftzeit für Nutzungsentschädigung auf 12 Monate"
				// if "Dach eines Wohn- und Geschäftsgebäudes" (f_phvo_mo_2) or "Dach eines gewerblich genutzten - Gebäudes" (f_phvo_mo_3) is selected
				if (JQ("#f_phvo_mo_2").is(":checked") || JQ("#f_phvo_mo_3").is(":checked")) {
					JQ("#div_phvo_ne12").show();
				} else {
					JQ("#div_phvo_ne12").hide();
				}

				// hide sachversicherung for balkonanlagen
				if (JQ("#f_phvo_mo_4").is(":checked")) {
					JQ("#div_phvo_sach").hide();
					JQ('#btn_phvo_sb_150').click();
					JQ('#btn_phvo_sb_500').attr('disabled', true)
					JQ('#btn_phvo_sb_500').css('cursor', 'not-allowed')
					JQ('#btn_phvo_sb_1000').attr('disabled', true)
					JQ('#btn_phvo_sb_1000').css('cursor', 'not-allowed')

				} else {
					JQ("#div_phvo_sach").show();
					JQ('#btn_phvo_sb_500').attr('disabled', false)
					JQ('#btn_phvo_sb_500').css('cursor', 'pointer')
					JQ('#btn_phvo_sb_1000').attr('disabled', false)
					JQ('#btn_phvo_sb_1000').css('cursor', 'pointer')
				}

				ALL.notifyHeight();

				if (PHVO.haveInfo() && !JQ("#f_phvo_ded_2").is(":checked")) {
					BC.debug('PHVO.chkDivReady(): ' + d + ' is ready!', '', 64);
					ALL.steps[1] = 3;
					return true;
				}

				ALL.chgMobButton('#btn_fwd_2', false);
				break;
			case '#div_3':
				var isOlderThanOneYear = moment(JQ('#f_phvo_ib').val(), 'DD.MM.YYYY').add(1, "y").isBefore(moment());
				if (isOlderThanOneYear) {
					JQ("#div_phvo_me").hide();
				} else {
					JQ("#div_phvo_me").show();
				}
				ALL.notifyHeight();

                if ((JQ('#f_vn_anrede').val() == '1' ||
                    JQ('#f_vn_anrede').val() == '2' ||
                    JQ('#f_vn_anrede').val() == '5')) {

                    JQ('#l_vn_nachname').text("Nachname");
                    JQ('#f_vn_nachname').prop('placeholder', "Nachname");
                    JQ('#f_vn_gebdat').prop('required', true);
                    JQ('#f_vn_vorname').prop('required', true);
                    JQ('#f_vn_gebdat').parent().show();
                    JQ('#f_vn_vorname').parent().show();

                } else if (JQ('#f_vn_anrede').val() === '4') {
                    JQ('#l_vn_nachname').text("Firma");
                    JQ('#f_vn_nachname').prop('placeholder', "Firmenname");
                    JQ('#f_vn_gebdat').prop('required', false);
                    JQ('#f_vn_vorname').prop('required', false);
                    JQ('#f_vn_gebdat').parent().hide();
                    JQ('#f_vn_vorname').parent().hide();
                }

                if (JQ('#f_vn_anrede').val() === '4') {
                    if (ALL.haveVN() && ALL.steps[1] >= 3) {
                        BC.debug('PHVO.chkDivReady(): ' + d + ' is ready!', '', 64);
                        return true;
                    }
                    ALL.chgMobButton('#btn_fwd_3', false);
				    break;
                }

                if (ALL.isVNcompleted() &&
                    ALL.haveVN() &&
                    ALL.steps[1] >= 3) {
                    ALL.steps[1] = 4;
                    BC.debug('PHVO.chkDivReady(): ' + d + ' is ready!', '', 64);
                    return true;
                }
                ALL.chgMobButton('#btn_fwd_3', false);
                break;
            case '#div_4':
                PRIV.canDA = false;
                r = PHVO.chkDA(4);
                BC.debug('PHVO.chkDivReady(): #div_4 ready is', r, 64);
                JQ('#a_da_wording').attr('href', PHVO.getWordingLink());
                if (r) return true;
                BC.debug('PHVO.chkDivReady(): #div_4 is NOT ready!', '', 64);
                ALL.chgMobButton('#btn_fwd_4', false);
                break;
            case '#div_5':
                PRIV.canDA = false;
                PHVO.setChkFlds();
                r = PHVO.chkDA(5);
                BC.debug('PHVO.chkDivReady(): #div_5 ready is', r, 64);
                if (r) return true;
                BC.debug('PHVO.chkDivReady(): #div_5 is NOT ready!', '', 64);
                ALL.chgMobButton('#btn_fwd_5', false);
                break;
            case '#div_98':
                return true;
            case '#div_99':
                JQ('#div_' + PHVO.type + '_rslt').hide();
                ALL.triggerDataLayerEvent('Photovoltaik', PHVO.type);
                return true;
            default:
                BC.debug('PHVO.chkDivReady() switch to default, BAD THING [tm]:', d, 16);
                break;
        }

		BC.debug('PHVO.chkDivReady(): ' + d + ' is NOT ready!', '', 64);
		return false;
    },

    chkKeys: function(e) {
		BC.debug('PHVO.chkKeys(): called', e, 64);

		var vs = JQ('#f_' + PHVO.type + '_vs').val();

		var vsi;

		var pv_hp = JQ('#f_' + PHVO.type + '_pv_1').is(':checked') || JQ('#f_' + PHVO.type + '_hp_1').is(':checked');

		var type = JQ('#div_' + PHVO.type + '_mo input:checked').val();
		BC.debug('PHVO.chkKeys(): key pressed: '+ e.key +' vs.len=' + vs.length + ', pv.mo=' + type, '', 64);

		try {
			vsi  = parseInt(vs);
		}
		catch(e) {
			BC.debug('PHVO.chkKeys(): raised exception:', e, 64);

			vsi = 0;

			JQ('#f_' + PHVO.type + '_vs').val(vsi);
		}

		if (!isNaN(vsi) && vsi > 250000) {
			ALL.showHint('Anlagen mit einem Wert über 250.000 € sind online nicht versicherbar, der Wert wurde entsprechend korrigiert.');

			vsi = 250000;

			JQ('#f_' + PHVO.type + '_vs').val(vsi);
		}

		if (type == '9') {
			ALL.showHint('Fassaden-, Vertikal oder Bodenanlagen sind online nicht versicherbar.');
		} else if (pv_hp && !isNaN(vsi) && vs.length > 4 && vsi >= 10000 && vsi <= 250000 && (type == '1' || type == '2')) {
			BC.debug('PHVO.chkKeys(): 1st calc is possible!', '', 64);
			ALL.chgMobButton('#btn_fwd_1', true);
			PHVO.change();
			return;
		}

		BC.debug('PHVO.chkKeys(): 1st calc is NOT possible!', '', 64);
		ALL.chgProduct(PHVO.type, 0);
		ALL.chgMobButton('#btn_fwd_1', false);
    },

    getWordingLink: function() {
        var bparts = ['phvo'];
	if (JQ('#f_' + PHVO.type + '_pv_1').is(':checked')) bparts.push('pv');
	if (JQ('#f_' + PHVO.type + '_hp_1').is(':checked')) bparts.push('hp');
        return '/TR/getzip?zip=B-' + bparts.join('-') + '.zip';
    },

    haveInfo: function() {
		if (!ALL.mobile) {
			JQ('#b_' + PHVO.type + '_go2datavn').button("option", "disabled", false);
			return true;
		}

		var valid = false;

		if (null !== JQ("#f_phvo_str").val() && 0 !== JQ("#f_phvo_str").val().length) {
			valid = true;
		}

		if (valid) {
			JQ('#a_' + PHVO.type + '_da').show();
		} else {
			JQ('#a_' + PHVO.type + '_da').hide();
		}

		JQ('#b_' + PHVO.type + '_go2datavn').button("option", "disabled", !valid);

		BC.debug('PHVO.haveInfo() => ', valid , 64);
ALL.notifyHeight();
		return valid;
    },

    havePeril: function(e) {
		BC.debug('PHVO.havePeril(): Checking ...', '', 64);

		var valid = false;

		PRIV.bparts[PHVO.type] = [];

		if (ALL.mobile) {
			PHVO.v_peril = JQ('#f_' + PHVO.type + '_pv_1').is(':checked') || JQ('#f_' + PHVO.type + '_hp_1').is(':checked');

			BC.debug('PHVO.havePeril(): ', PHVO.v_peril, 64);

			return PHVO.v_peril;
        }

		JQ.each(['pv', 'hp'], function(i, v) {
			if (JQ('#f_phvo_' + v).is(':checked')) {
				JQ('#div_phvo_' + v + '_1').show();
				valid = true;
				PRIV.bparts[PHVO.type].push(v);
			} else {
				JQ('#f_phvo_net2_' + v).text('0,00 €');
				JQ('#div_phvo_' + v + '_1').hide();
				// JQ('#div_phvo_rslt').hide();
			}
		});
		ALL.notifyHeight();

		// if (!JQ('#f_phvo_pv').is(':checked') && !JQ('#f_phvo_hp').is(':checked')) {
		// 	if (!PHVO.dry) {
		// 		ALL.showHint('Photovoltaik: Bitte mindestens All-Risk-Deckung oder Haftpflichtdeckung auswählen.', 1);
		// 	}
		//
		// 	BC.debug('PHVO.havePeril(): Missing phvo_pv / phvo_hp', '', 64);
		//
		// 	// JQ('#div_phvo_pv_1').hide();
		//
		// 	// JQ('#div_phvo_hp_1').hide();
		//
		// 	JQ('#div_phvo_rslt').hide();
		//
		// 	return false;
		// }

		if (valid && !JQ("#div_phvo_pv input[name='phvo_me']").is(':checked')) {
			if (!PHVO.dry) {
				ALL.showHint('Photovoltaik: Bitte angeben, ob auch der Minderertrag mitversichert werden soll.', 1);
			}

			BC.debug('PHVO.havePeril(): Missing phvo_me', null, 64);

			valid = false;
		}

		if (valid && !JQ("#div_phvo_pv input[name='phvo_ne12']").is(':checked')) {
			if (!PHVO.dry) {
				ALL.showHint('Photovoltaik: Bitte angeben, ob die Haftzeit für Nutzungsentschädigung verlängert werden soll.', 1);
			}

			BC.debug('PHVO.havePeril(): Missing phvo_ne12', null, 64);

			valid = false;
		}

		// disable "Ausschluss Feuer vom Versicherungs-schutz"
		// if (valid && !JQ("#div_phvo_pv input[name='phvo_f0']").is(':checked')) {
		// 	if (!PHVO.dry) {
		// 		ALL.showHint('Photovoltaik: Bitte angeben, ob Schäden aufgrund von Feuer vom Versicherungsschutz ausgeschlossen werden sollen.', 1);
		// 	}
		//
		// 	BC.debug('PHVO.havePeril(): Missing phvo_f0', null, 64);
		//
		// 	valid = false;
		// }

		// disable "Ausschluss Leitungswasser vom Versicherungs-schutz"
		// if (valid && !JQ("#div_phvo_pv input[name='phvo_lw0']").is(':checked')) {
		// 	if (!PHVO.dry) {
		// 		ALL.showHint('Photovoltaik: Bitte angeben, ob Leitungswasserschäden vom Versicherungsschutz ausgeschlossen werden sollen.', 1);
		// 	}
		//
		// 	BC.debug('PHVO.havePeril(): Missing phvo_lw0', null, 64);
		//
		// 	valid = false;
		// }

		if (valid && !JQ("#div_phvo_pv input[name='phvo_sb']").is(':checked')) {
			if (!PHVO.dry) {
				ALL.showHint('Photovoltaik: Bitte angeben, in welcher Höhe eine Selbstbeteiligung gewünscht wird.', 1);
			}

			BC.debug('PHVO.havePeril(): Missing phvo_sb', null, 64);

			valid = false;
		}

		// only show "Erhöhung der Haftzeit für Nutzungsentschädigung auf 12 Monate"
		// if "Dach eines Wohn- und Geschäftsgebäudes" (f_phvo_mo_2) or "Dach eines gewerblich genutzten - Gebäudes" (f_phvo_mo_3) is selected
		if (JQ("#f_phvo_mo_2").is(":checked") || JQ("#f_phvo_mo_3").is(":checked")) {
			JQ("#phvo-haftzeit-erhoehung").show();
			JQ("#div_phvo_ne12").show();
		} else {
			JQ("#div_phvo_ne12").hide();
			JQ("#phvo-haftzeit-erhoehung").hide();
			JQ("#f_phvo_ne12_0").click();
		}

		// hide Minderertragsversicherung when "Dach Balkonanlage" is selected
		var isOlderThanOneYear = moment(JQ('#f_phvo_ib').val(), 'DD.MM.YYYY').add(1, "y").isBefore(moment());

		if (JQ("#f_phvo_mo_4").is(":checked")) {
			JQ("#div_phvp_pv_me").hide();
			JQ("#additional-risks-heading").hide();
			JQ("#div_phvo_me").hide();
			JQ("#f_phvo_me_0").click();
			JQ('#f_phvo_sb_150').click();
            JQ('#f_phvo_sb_500').attr('disabled', true)
            JQ('#f_phvo_sb_1000').attr('disabled', true)
		} else if (isOlderThanOneYear) {
			JQ("#div_phvp_pv_me").hide();
			JQ("#div_phvo_me").hide();
			JQ('#f_phvo_me_0').click();
		} else {
			JQ("#div_phvp_pv_me").show();
			JQ("#div_phvo_me").show();
			JQ("#additional-risks-heading").show();
			JQ("#div_phvo_me").show();
			JQ('#f_phvo_sb_500').attr('disabled', false)
            JQ('#f_phvo_sb_1000').attr('disabled', false)
		}

		// only show "Hersteller des Batteriespeicher-systems" && "Typbezeichnung des Batterie-speichersystems"
		// if "Anlage verfügt über Batteriespeichersystem" (f_phvo_batsys_1) is checked
		if (JQ("#f_phvo_batsys_1").is(":checked")) {
			JQ("#div_phvo_batprod").show();
			JQ("#div_phvo_battyp").show();
		} else {
			JQ("#div_phvo_batprod").hide();
			JQ("#div_phvo_battyp").hide();
			// reset inputs if the fields are not needed anymore
			JQ("#f_phvo_batprod").val("");
			JQ("#f_phvo_battyp").val("");
		}

		PHVO.adjustDate()

		PHVO.v_peril = valid;

		//if (! valid) ALL.chgProduct(PHVO.type, null);

		BC.debug('PHVO.havePeril(): ', valid, 64);
ALL.notifyHeight();
		return valid;
    },

	adjustDate: function () {
		BC.debug('PHVO.adjustDate():', [], 64);
		var start = JQ('#f_phvo_start');
		var end = JQ('#f_phvo_ende');

		var format = "DD.MM.YYYY";
		var startMoment = moment(start.val(), format);
		var endMoment = moment(end.val(), format);

		var startPlus3y = startMoment.clone().add(3, 'y');
		var minMoment = startMoment.clone().add(1, 'y');
		var minDate = '+1y1d';
		var maxDate = '+2y';

		if (JQ('#f_phvo_dnls').length && JQ('#f_phvo_dnls').is(':checked')) {
			minMoment = startPlus3y
			minDate = '+3y1d';
			maxDate = '+4y';
		}

		var maxMoment = minMoment.clone().add(1, 'y');
		var datepickerOptions = {changeMonth: true,
			changeYear: true,
			defaultDate: minDate,
			maxDate: maxDate,
			minDate: minDate,
			showOn: ALL.mobile  ? 'focus' : 'both',
		}

		BC.debug('PHVO.adjustDate(): Dates', {'minimumDate': minMoment, 'maximumDate': maxMoment, 'start': startMoment, 'end': endMoment}, 64);

		if (endMoment.isBefore(minMoment) || endMoment.isAfter(maxMoment)) {
			BC.debug('PHVO.adjustDate(): Date is changed.', {'minimumDate': minMoment, 'maximumDate': maxMoment, 'start': startMoment, 'end': endMoment}, 64)
			end.val(minMoment.format(format));
		}

		BC.debug('PHVO.adjustDate(): adjusting datepicker widget.', datepickerOptions, 64);

		// adjusting the date picker here to ge a visual feedback for the allowed values.
		// previously the value just silently reset.
		end.datepicker("destroy");
		end.datepicker(datepickerOptions);
		ALL.notifyHeight();
	},

    haveRisk: function(e) {
		BC.debug('PHVO.haveRisk(): Checking ...', '', 128);

		// valid = true : Alle Risikomerkmale vorhanden
		var valid = true;

		var _vs  = parseInt(JQ('#f_phvo_vs').val());

		var _kwp = parseInt(JQ('#f_phvo_kwp').val());

		var _ib  = parseInt(JQ('#f_phvo_ib').val());

		if (valid && ! _vs) {
			if (! PHVO.dry) {
				ALL.showHint('Photovoltaikversicherung: Bitte die Versicherungssumme angeben.', 1);
			}

			BC.debug('PHVO.haveRisk(): Missing VS', '', 64);

			valid = false;
		} else if (valid && _vs > 250000) {
			//if (! PHVO.dry) {
				ALL.showHint('Photovoltaikversicherung: Die VS der Anlage liegt über 250.000 €, eine Online-Tarifierung ist nicht möglich.', 1);
			//}

			BC.debug('PHVO.haveRisk(): VS greater 500', '', 64);

			valid = false;
		}

		if (valid && ! _kwp) {
			if (! PHVO.dry) {
				ALL.showHint('Photovoltaikversicherung: Bitte die Leistung der Anlage angeben.', 1);
			}

			BC.debug('PHVO.haveRisk(): Missing kWp', '', 64);

			valid = false;
		}

		if (! ALL.mobile && valid && ! _ib) {
			if (! PHVO.dry) {
				ALL.showHint('Photovoltaikversicherung: Bitte das Datum der Inbetriebnahme angeben.', 1);
			}

			BC.debug('PHVO.haveRisk(): Missing IB', '', 64);

			valid = false;
		} else if (valid) {
			// Auf Alter prüfen und Minderertragsversicherung bei Alter > 1 Jahr disablen!
			var t0 = moment(JQ('#f_phvo_ib').val(), 'DD.MM.YYYY');

			var t1 = moment(JQ('#f_phvo_start').val(), 'DD.MM.YYYY');

			BC.debug('PHVO.haveRisk(): t1.diff =>', t1.diff(t0, 'days'), 64);

			if (t1.diff(t0, 'y', true) > 10) {
				valid = false;

				// JQ('#f_phvo_pv').attr('checked', false);

				// JQ('#f_phvo_pv_1').attr('checked', false);

				// JQ('#div_phvo_pv_1').hide();

				if (!JQ('#f_phvo_plz').val()) {
                    JQ('#div_phvo_rslt').hide();
                }

				// JQ('#f_phvo_hp').attr('checked', false);

				// JQ('#f_phvo_hp_1').attr('checked', false);

				// JQ('#div_phvo_hp_1').hide();

				ALL.showHint('Anlagen, die älter als 10 Jahre sind, können nicht versichert werden.');
			}
		}
		ALL.notifyHeight();

		// disable / delete DIN EN 1991 check see WALD-536
		// if (! ALL.mobile && valid && ! JQ("#div_phvo_risk input[name='phvo_en1991']").is(':checked')) {
		//     if (! PHVO.dry) {
		// 	ALL.showHint('Photovoltaikversicherung: Bitte angeben, ob das Montagesystem der Anlage nach DIN EN 1991 geprüft wurde.', 1);
		//     }
		//     BC.debug('PHVO.haveRisk(): Missing Check EN 1991', '', 64);
		//     valid = false;
		// } else if (valid && JQ("#f_phvo_en1991_0").is(':checked')) {
		//     JQ('#f_phvo_pv').prop('checked', false);
		//     ALL.showHint('Photovoltaik: Eine Anlage ohne geprüftes Montagesystem nach DIN EN 1991 ist nicht versicherbar.');
		//     valid = false;
		// }

		if (! ALL.mobile && valid && ! JQ("#div_phvo_risk input[name='phvo_batsys']").is(':checked')) {
			if (! PHVO.dry) {
				ALL.showHint('Photovoltaikversicherung: Bitte angeben, ob Anlage über ein Batteriespeichersystem verfügt.', 1);
			}

			BC.debug('PHVO.haveRisk(): Missing BatSys', '', 64);

			valid = false;
		}

		if (! ALL.mobile && valid && ! JQ("#div_phvo_risk input[name='phvo_mo']").is(':checked')) {
			if (! PHVO.dry) {
				ALL.showHint('Photovoltaikversicherung: Bitte Montageort angeben.', 1);
			}

			BC.debug('PHVO.haveRisk(): Missing MO', '', 64);

			valid = false;
		}

		if (valid && JQ('#f_phvo_mo_2').is(':checked') || JQ('#f_phvo_mo_3').is(':checked')) {
			JQ('#div_phvo_flamcbm').show();

			JQ('#div_phvo_gwbetrieb').show();

			if (JQ('#f_phvo_gwbetrieb').val() == '---') {
				JQ('#f_phvo_gwbetrieb').val('');
			}
		} else if (valid) {
			JQ('#div_phvo_flamcbm').hide();

			JQ('#div_phvo_gwbetrieb').hide();

			JQ('#f_phvo_flamcbm').val('0');

			JQ('#f_phvo_gwbetrieb').val('---');
		}

		if (!ALL.mobile && valid && !JQ("#div_phvo_risk input[name='phvo_gr']").is(':checked')) {
			if (! PHVO.dry) {
				ALL.showHint('Photovoltaikversicherung: Bitte Eigentumsverhältnisse zum Montageort angeben.', 1);
			}

			BC.debug('PHVO.haveRisk(): Missing GR', '', 64);

			valid = false;
		}

		// not valid if "Fassaden-, Vertikal- und Bodenanlagen" from Montageort is selected (WALD-536).
		if (JQ("#f_phvo_mo_9").is(":checked")) {
			valid = false;

			if (!JQ('#f_phvo_plz').val()) {
			    JQ('#div_phvo_rslt').hide();
			}
		}

		// not valid if "Aufgeständert" from Montageart is selected (WALD-536).
		if (JQ("#phvo_montageart_aufgestaendert").is(":checked")) {
			var message = "Aufgeständerte Solaranlagen sind online nicht versicherbar. <br/> <br/> Bitte wenden Sie sich direkt an die Waldenburger Versicherung AG"

			valid = false;

			ALL.showHint(message, false, true);

            if (!JQ('#f_phvo_plz').val()) {
			    JQ('#div_phvo_rslt').hide();
			}
		}

		// not valid if "Art der Bedachung" is "weich" (f_phvo_ded_2)
		if (JQ("#f_phvo_ded_2").is(":checked")) {
			//right message ? :D
			var message = "Keine Zeichnung von Solaranlagen auf Dächern mit weicher Bedachung möglich."

			ALL.showHint(message, false, true);

			JQ('#b_phvo_go2datavn').toggleClass("ui-button-disabled ui-state-disabled", valid);
		}

		// not valid if "PLZ" is missing
		if (valid && !JQ("#f_phvo_plz").val()) {
			JQ('#b_phvo_go2datavn').toggleClass("ui-button-disabled ui-state-disabled", valid);
		}

		// not valid if "Lagerung feuergefährlicher Stoffe im Gebäude (f_phvo_flamcbm)" is > 50
		if (parseInt(JQ("#f_phvo_flamcbm").val()) > 50) {
			var message = "Solaranlagen auf Gebäuden mit Lagerung von feuergefährlichen Stoffen über 50 cbm sind online nicht versicherbar. <br/> <br/> Bitte wenden Sie sich direkt an die Waldenburger Versicherung AG"

			ALL.showHint(message, false, true);

			ALL.chgMobButton('#btn_fwd_2', false);

			JQ('#b_phvo_go2datavn').toggleClass("ui-button-disabled ui-state-disabled", valid);
		}

		if (!ALL.mobile) {
			// JQ('#f_phvo_pv').prop('disabled', !valid);

			JQ('#f_phvo_hp').prop('disabled', !valid);

			// if (!valid) {
			// 	PHVO.unset();
			// }
		}

		BC.debug('PHVO.haveRisk(): ', valid, 64);

		PHVO.v_risk = valid;
ALL.notifyHeight();
		return valid;
    },

	showCommercialBuildingMessage: function () {
		var isCommercialBuildingHtml = "<span>Anlagen auf  Gebäuden von feuergefährdeten Betrieben sind online nicht versicherbar."+
			"<br/><br/> Darunter fallen:</span>" +
			"<ul style='margin: 10px; padding: 10px;'>" +
			"<li>Landwirtschaftliche Betriebe</li>" +
			"<li>Recyclingbetriebe</li>" +
			"<li>Papierherstellung/-verarbeitung</li>" +
			"<li>Mälzereien</li>" +
			"<li>Asylanten-/Obdachlosenheime</li>" +
			"<li>Chemische Industrie</li>" +
			"<li>Diskotheken, Bar, Tanzlokale, Kartbahnen, Spielhallen</li>" +
			"<li>Gaswerke</li>" +
			"<li>Getreidemühlen</li>" +
			"<li>Gießereien</li>" +
			"<li>Glasherstellung</li>" +
			"<li>Holzbe- und verarbeitung</li>" +
			"<li>Kunstoffherstellung und -verarbeitung</li>" +
			"<li>Lack-/Farbenherstellung</li>" +
			"<li>Textilherstellung</li>" +
			"</ul>";

		ALL.showHint(isCommercialBuildingHtml, false, true);
		ALL.notifyHeight();
	},

    init: function() {
    	PRIV.createBundleRabattFieldsForBranch('phvo');
    	PRIV.hideLogoutAndAdministration();

        if (ALL.mobile && ALL.branch.slice(0, 4) != PHVO.branch) {
			return;
		}

		var ib =  JQ('#f_phvo_ib');
		ib.datepicker("destroy");
        ib.datepicker({
            changeMonth: true,
			changeYear: true,
			defaultDate: null,
			maxDate: '+2y',
			minDate: '-10y',
		});

		ib.change(function (e) {
		    ib.mask("99.99.9999");
		});

		BC.debug('PHVO.init():', '', 64);

		JQ('#div_phvo_vers').change(PHVO.change);

		if (ALL.mobile && !JQ('#div_phvo_vers').length) {
			return;
		}

		ALL.chgProduct(PHVO.type, null);

		ALL.chgMobButton('#btn_fwd_1', false);

		JQ('#f_' + PHVO.type + '_vs').keyup(PHVO.chkKeys);

		// validate price not < 500 and not > 250k
		JQ('#f_' + PHVO.type + '_vs').change(function (e) {
			var valid = true;
			var input = e.currentTarget;

			if (!input) {
				return;
			}

			var value = parseInt(input.value);
			var priceToLowMessage = "Die Versicherungssumme der Anlage muss mindestens 500 € betragen.";
			var priceToHighMessage = "Photovoltaikversicherung: Die VS der Anlage liegt über 250000 €, eine Online-Tarifierung ist nicht möglich.";

			if (500 > value) {
				ALL.showHint(priceToLowMessage, false, true);
				valid = false;
			}

			if (250000 < value) {
				ALL.showHint(priceToHighMessage, false, true);
				valid = false;
			}

			if (!valid) {
				JQ(input).val(500);
			}
		});

		// add handlers for two specific _mo (montageort) fields that should show a hint (see WALD-536)
		JQ("#f_phvo_mo_2").click(PHVO.showCommercialBuildingMessage);
		JQ("#f_phvo_mo_3").click(PHVO.showCommercialBuildingMessage);

		// decline injurance for 'f_phvo_mo_9' option in montageort
		JQ("#f_phvo_mo_9").click(function () {
			ALL.showHint("Solaranlagen am angegebenen Montageort sind online nicht versicherbar. <br/><br/> Bitte wenden Sie sich direkt an die Waldenburger Versicherung AG", false, true);
		});

        JQ("#f_phvo_me_0").click(function () {
            JQ("#phvo-section-dach-balkonanlage").show();
            ALL.notifyHeight();
        });

		JQ('#div_' + PHVO.type + '_pv_hp').change(PHVO.chkKeys);

		JQ('#div_' + PHVO.type + '_mo').change(PHVO.chkKeys);

		JQ('#div_' + PHVO.type + '_sb button').click(PHVO.chgSB);

		JQ('#f_' + PHVO.type + '_start').val(tomorrow);

		JQ('#f_' + PHVO.type + '_ib').val(today);

		JQ('#f_' + PHVO.type + '_ende').val(tomorrowInOneYear);

		//JQ('#div_phvo_batsys').change(PHVO.setbatsys);

		JQ('.box input').keyup(ALL.chkDivReady2);

		JQ('#a_da_wording').click(function() {
			PRIV.wd_read=true;
			ALL.chkDivReady('a_da_wording', true);
			ALL.chgMobButtons(ALL.branch);
		});

		JQ("#f_phvo_dnls").click(PHVO.adjustDate);
		ALL.notifyHeight();
    },

    recalc: function(e) {
		BC.debug('PHVO.recalc():', '', 256);

		if (! PHVO.canCalc()) {
			BC.debug('PHVO.recalc():', 'Cannot calc - check logs!', 64);
			return;
		}

		var sa = PRIV.make_sa('phvo');

		BC.debug('PHVO.recalc():', sa, 256);

		JQ.getJSON(JSONURI, sa, PHVO.setPremium);

		ALL.chkContactData();

		PHVO.adjustDate()
		ALL.notifyHeight();
    },

    setChkFlds: function () {
	// Belege Felder in "Angaben überprüfen"
	// Aufruf teilweise in ALL.set_HNR
	if (! ALL.mobile) return;
	if (JQ('#f_' + PHVO.type + '_pv_1').is(':checked')) {
	    JQ('#m098_pv').text('Ja');
	    JQ('#div098_me').show();
	    JQ('#m098_me').text(ALL.getYN('f_' + PHVO.type + '_me_1'));
	    JQ('#div098_ne12').show();
	    JQ('#m098_ne12').text(ALL.chkChkBox('f_' + PHVO.type + '_ne12_1') ? '12 Monate' : '6 Monate');
	    JQ('#div098_f0').show();
	    JQ('#m098_f0').text(ALL.getYN('f_' + PHVO.type + '_f0_1'));
	    JQ('#div098_lw0').show();
	    JQ('#m098_lw0').text(ALL.getYN('f_' + PHVO.type + '_lw0_1'));
	    JQ('#div098_sb').show();
	    JQ('#m098_sb').text(JQ('#f_' + PHVO.type + '_sb').val() + ' €');
	} else {
	    JQ('#m098_pv').text('Nein');
	    JQ('#div098_me').hide();
	    JQ('#m098_me').empty();
	    JQ('#div098_ne12').hide();
	    JQ('#m098_ne12').empty();
	    JQ('#div098_f0').hide();
	    JQ('#m098_f0').empty();
	    JQ('#div098_lw0').hide();
	    JQ('#m098_lw0').empty();
	    JQ('#div098_sb').hide();
	    JQ('#m098_sb').empty();
	}
	if (JQ('#f_' + PHVO.type + '_hp_1').is(':checked')) {
	    JQ('#m098_hp').text('Ja');
	    JQ('#div098_hpvs').show();
	    JQ('#m098_hpvs').text(JQ('#f_' + PHVO.type + '_hpvs_10').is(':checked') ? '10 Mio €' : '5 Mio €');
	} else {
	    JQ('#m098_hp').text('Nein');
	    JQ('#div098_hpvs').hide();
	    JQ('#m098_hpvs').empty();
        }
        JQ('#m098_vo').text(ALL.adr.plz + ' ' + ALL.adr.ort + ', ' +
                            ALL.adr.str + ' ' + ALL.adr.hnr);
	JQ('#m098_vs').text(JQ('#f_' + PHVO.type + '_vs').val() + ' €');
	JQ('#m098_kwp').text(JQ('#f_' + PHVO.type + '_kwp').val());
	JQ('#m098_ib').text(JQ('#f_' + PHVO.type + '_ib').val());
	JQ('#m098_en1991').text(ALL.getYN('f_' + PHVO.type + '_en1991_1'));
	JQ('#m098_batsys').text(ALL.getYN('f_' + PHVO.type + '_batsys_1'));
        if (! ALL.chkChkBox('f_' + PHVO.type + '_batsys_1')) {
            JQ('#div098_batprod').hide();
            JQ('#div098_battyp').hide();
        } else {
            JQ('#div098_batprod').show();
            JQ('#div098_battyp').show();
	    JQ('#m098_batprod').text(JQ('#f_' + PHVO.type + '_batprod').val());
	    JQ('#m098_battyp').text(JQ('#f_' + PHVO.type + '_battyp').val());
        }
	var _mos = {'1': 'Dach eines privaten Wohnhauses',
		    '2': 'Dach eines gewerblich genutzten Gebäudes',
		    '3': 'Dach eines landwirtschaftlich genutzten Gebäudes',
		    '9': 'Fassaden-, Vertikal- und Bodenanlagen'};
	var _mo = JQ('#div_' + PHVO.type + '_mo input[name="phvo_mo"]').val();
	JQ('#m098_mo').text(_mos[_mo]);
        JQ('#m098_ded').text(ALL.chkChkBox('f_' + PHVO.type + '_ded_1') ? 'Hart' : 'Weich');
        JQ('#m098_gr').text(ALL.chkChkBox('f_' + PHVO.type + '_gr_0') ?
                            'Anlage auf eigenem Grundstück / Gebäude' :
                            'Anlage auf fremdem / gemietetem Grundstück / Gebäude');
    JQ('#m098_batprod').text(JQ('#f_' + PHVO.type + '_batprod').val() || 'Bitte ergänzen');
	JQ('#m098_battyp').text(JQ('#f_' + PHVO.type + '_battyp').val()  || 'Bitte ergänzen');
	JQ('#m098_modprod').text(JQ('#f_' + PHVO.type + '_modprod').val() || 'Bitte ergänzen');
	JQ('#m098_modtyp').text(JQ('#f_' + PHVO.type + '_modtyp').val()  || 'Bitte ergänzen');
	JQ('#m098_installer').text(JQ('#f_' + PHVO.type + '_installer').val());
        if (ALL.chkChkBox('f_' + PHVO.type + '_mo_2')) {
            JQ('#div098_flamcbm').show();
            JQ('#div098_gwbetrieb').show();
	    JQ('#m098_flamcbm').text(JQ('#f_' + PHVO.type + '_flamcbm').val());
	    JQ('#m098_gwbetrieb').text(JQ('#f_' + PHVO.type + '_gwbetrieb').val()  || 'Bitte ergänzen');
        } else {
            JQ('#div098_flamcbm').hide();
            JQ('#div098_gwbetrieb').hide();
            JQ('#m098_flamcbm').empty();
            JQ('#m098_gwbetrieb').empty();
        }
        ALL.setChkFlds(PHVO.type);
        ALL.notifyHeight();
    },

    setPremium: function(data) {
		BC.debug('PHVO.setPremium():', data, 64);

		if (plzInProgress) return;

        shouldCheckPlz = JQ('#f_phvo_plz').val() != lastPLZ;
        if (JQ('#f_phvo_plz').val() && shouldCheckPlz) {
            plzInProgress = true;
            lastPLZ = JQ('#f_phvo_plz').val();
            shouldCheckPlz = false;
            lastPLZ = JQ('#f_phvo_plz').val();
            ALL.branch = 'phvo'
            ALL.setAdr();
            plzInProgress = false;
            return;
        }

		ALL.chkError(data);

		if (data.ERROR) {
		    PHVO.valid = false;
		    if (data.DirA[0] == "Photovoltaikanlagen am angegeben Risikoort sind online nicht versicherbar.Bitte wenden Sie sich direkt an die Waldenburger.") {
		        JQ('#div_phvo_rslt').show()
                JQ('#b_phvo_go2datavn').addClass("ui-button-disabled ui-state-disabled");
		    }
		    ALL.notifyHeight();
			return;
		}

		ALL.setZWs(data);

		JQ.each(data, function(key, val) {
			if (key == 'DirA' && val && val.length) {
				PRIV.setDirAnfrage(val);
				return;
			} else if (JQ('#f_phvo_' + key).length) {
				if (key == 'net2_pv' && data.net2_me && data.net2_me.val) {
					// Dirty Hack wegen ticket:371 - separater Ausweis von Sach- und Minderertragsdeckung
					JQ("#f_phvo_" + key).text(ALL.flt2cur(val.val + data.net2_me.val));
				} else {
					JQ("#f_phvo_" + key).text(val.str);
				}
			}

			if (key == 'mpr2' && val.val == data.net2.val) {
				JQ('#l_phvo_net2').text('Jährliche Nettoprämie Photovoltaikversicherung (Mindestprämie!):');
			} else if (key == 'mpr2') {
				JQ('#l_phvo_net2').text('Jährliche Nettoprämie Photovoltaikversicherung:');
			}

			if (key == 'brt1' && val.str) {
				ALL.chgProduct('phvo', val.str);
			}
		});

		PHVO.valid = true;
    },

    unset: function(e) {
		// this should not be needed anymore
		// JQ.each(['hp', 'pv'], function(i, v) {
			// JQ('#f_' + PHVO.type + '_net2_' + v).text('0,00 €');
			// JQ('#div_' + PHVO.type + '_' + v + '_1').hide();
			// JQ('#f_' + PHVO.type + '_' + v).prop('checked', false);
		// });
    },
};
